(function (featureFlags) {
  'use strict';

  function amplitudeFeatureFlagIdentify() {
    const FLAG_NAME_MAP = {};

    if (featureFlags) {
      const identity = new amplitude.Identify();

      Object.keys(featureFlags).forEach((flagName) => {
        identity.set(FLAG_NAME_MAP[flagName], `${featureFlags[flagName]}`);
      });

      amplitude.getInstance().identify(identity);
    }
  }

  if (typeof amplitude !== 'undefined') {
    amplitudeFeatureFlagIdentify();
  }
})(window.feature_flags);
